import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TrainingModule } from '../training/training.module';

import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [DashboardComponent],
    imports: [CommonModule, TranslateModule, SharedModule, TrainingModule],
})
export class DashboardModule {}
